import { CheckCircle2, Clock } from "lucide-react";

export const chargeStatusHash = {
  paid: {
    color: 'text-green-400',
    badgeClass: 'bg-green-500/20 text-green-400 border-green-500/40',
    label: "Payment Processed",
    icon: <CheckCircle2 size={14} className="shrink-0" />
  },
  unpaid: {
    color: 'text-amber-400',
    badgeClass: 'bg-amber-500/20 text-amber-300 border-amber-500/40',
    label: "Payment Pending",
    icon: <Clock size={14} className="shrink-0" />
  }
}
